import React from 'react';
import { useLanguage } from '../pages/LanguageContext';
import {FaPhone} from 'react-icons/fa';

// Images for each section (you can replace them with your own)
import wifiImg from '../images/Network.avif';        // Replace with a networking image
import securityImg from '../images/Gemini_Generated_Image_t8wb0ot8wb0ot8wb.png'; // Replace with a security image
import intercomImg from '../images/intercome.jpg'; // Replace with an intercom image
import whyImg from '../images/network12.avif';           // (optional) For 'Why' section
import heroBgImg from '../images/tre.avif';

// ===== HERO TEXTS (EN & AR) =====
const heroTexts = {
  en: {
    title: "Network & Security Optimization",
    subtitle: "Build a stable, secure, and intelligent foundation for your smart home.",
    desc: "",
    bullets: [
      "Wi-Fi Coverage Planning & Elimination of Weak Zones",
      "Secure Device Integration & VLAN/Firewall Setup",
      "Network Performance Optimization & Diagnostics",
      "AI-Powered Security Cameras & Smart Sensors",
      "Custom Alarms, Notifications, & Smart Intercom",
      "Expert engineering, clean install, and ongoing support"
    ],
  },
  ar: {
    title: "تحسين الشبكة والأنظمة الأمنية",
    subtitle: "أساس المنزل الذكي يبدأ باتصال موثوق وحماية ذكية.",
    desc: "",
    bullets: [
      "تخطيط تغطية الواي فاي ومعالجة المناطق الضعيفة",
      "ربط الأجهزة الذكية بشكل آمن وإعداد VLAN/Firewall",
      "تحسين أداء الشبكة وتشخيص الأعطال",
      "كاميرات ذكية مدعومة بالذكاء الاصطناعي وحساسات أمنية",
      "إنذارات وتنبيهات مخصصة وإنتركم ذكي",
      "هندسة احترافية وتركيب نظيف ودعم مستمر"
    ],
  },
};


const styles = `
.cta-section {
  background: linear-gradient(115deg, #1a3070 12%, #59b8fd 110%);
  color: #fff;
  text-align: center;
  padding: 75px 20px 72px 20px;
  margin: 56px 0 0 0;
  border-radius: 38px 38px 0 0;
  box-shadow: 0 6px 38px 0 rgba(40,80,160,0.12);
  position: relative;
  z-index: 2;
  overflow: hidden;
}
.cta-section:after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at 82% 14%, #ffffff23 15%, transparent 65%), 
              radial-gradient(ellipse at 13% 98%, #ececec22 20%, transparent 90%);
  z-index: 0;
  pointer-events: none;
}
.cta-section h2 {
  font-size: 2.09rem;
  margin-bottom: 22px;
  font-weight: 800;
  color: #fff;
  text-shadow: 0 1px 4px #2a78c352;
  letter-spacing: -1px;
  position: relative;
  z-index: 1;
}
.cta-section p {
  font-size: 1.16rem;
  max-width: 620px;
  margin: 0 auto 32px;
  line-height: 2.1;
  color: #eaf6ff;
  position: relative;
  z-index: 1;
}
.cta-section a, .cta-section button {
  display: inline-block;
  background: linear-gradient(96deg,#ffe6cf 0%,#f2ecdf 100%);
  color: #164196;
  padding: 17px 46px;
  font-weight: 800;
  font-size: 1.08rem;
  border: none;
  cursor: pointer;
  border-radius: 14px;
  box-shadow: 0 2px 24px 0 rgba(0,0,0,0.08);
  text-decoration: none;
  margin-top: 10px;
  transition: background 0.22s, box-shadow 0.22s, color 0.22s, transform 0.23s;
  position: relative;
  z-index: 1;
  letter-spacing: -0.2px;
}
.cta-section a:hover, .cta-section button:hover {
  background: linear-gradient(93deg,#fff3e2 0%,#ffe6cf 100%);
  color: #0f2c6b;
  box-shadow: 0 4px 32px 0 rgba(36,120,190,0.13);
  transform: translateY(-2.5px) scale(1.037);
}
@media (max-width: 1100px) {
  .cta-section {
    border-radius: 19px 19px 0 0;
    padding: 46px 2vw 40px 2vw;
    font-size: 1rem;
  }
  .cta-section h2 {
    font-size: 1.25rem;
  }
}
@media (max-width: 680px) {
  .cta-section {
    border-radius: 10px 10px 0 0;
    padding: 27px 1vw 25px 1vw;
    font-size: 0.98rem;
  }
  .cta-section h2 {
    font-size: 1rem;
    margin-bottom: 12px;
  }
}
/* --- DARK MODE OVERRIDES FOR WHOLE PAGE --- */
.dark .services-wrapper {
  background: linear-gradient(120deg, #10121a 0%, #162345 100%) !important;
}
.dark .section-bg {
  opacity: 0.14 !important;
  background: radial-gradient(ellipse at 65% 30%, #092447 10%, transparent 70%), 
    radial-gradient(ellipse at 10% 70%, #234268 13%, transparent 90%) !important;
}
.dark .service-section,
.dark .service-section.reverse {
  background: rgba(25, 32, 55, 0.97) !important;
  border: 1.5px solid #20314e !important;
  box-shadow: 0 4px 36px 0 #16213b88, 0 2px 8px 0 #2038682a !important;
}
.dark .service-content,
.dark .reverse .service-content {
  background: rgba(16, 21, 37, 0.97) !important;
  color: #ffffffff !important;
  box-shadow: 0 2px 14px 0 #20386844 !important;
}
.dark .service-content h2 {
  
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.dark .service-content .subtitle {
  color: #ffffffff !important;
}
.dark .service-content li {
  color: #ffffffff !important;
}
.dark .service-content li:before {
  color: #ffffffff !important;
}
.dark .service-image img {
  border: 3.2px solid #2b425c !important;
  background: #16213b !important;
  filter: brightness(0.91) grayscale(0.09);
}

/* Dark Mode for CTA Section */
.dark .cta-section {
  background: linear-gradient(115deg, #000000ff 12%, #162345 110%) !important;
  
}
.dark .cta-section h2 {
  color: #1b4fbdff !important;
}
.dark .cta-section p {
  color: #ffffffff !important;
}
.dark .cta-section a,
.dark .cta-section button {
  background: linear-gradient(96deg, #02101e 0%, #145a9b 100%) !important;
  color: #eaf6ff !important;
}

/* Dark mode for Hero Section (if used) */
.dark .smart-hero-pro-wrapper {
  background: linear-gradient(106deg, #111827 80%, #18233a 100%) !important;
}
.dark .smart-hero-pro-bg-overlay {
  background: linear-gradient(115deg, #16213b99 18%, #232944c0 90%) !important;
 
}
.dark .smart-hero-pro-title {
  color: #1b4fbdff !important;
  background: linear-gradient(90deg, #61dafb 40%, #3fa6ed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 3px 18px #013a812a;
}
.dark .smart-hero-pro-subtitle {
  color: #1b4fbdff !important;
  text-shadow: 0 2px 14px #00132552;
}
.dark .smart-hero-pro-glass {
  background: rgba(15,22,37,0.96) !important;
  border: 1.6px solid #263b61 !important;
  color: #c9eaff !important;
  box-shadow: 0 10px 34px 0 #0d213677, 0 2px 10px 0 #0c1c3077 !important;
}
.dark .smart-hero-pro-desc,
.dark .smart-hero-pro-bullets li {
  color: #aee7ff !important;
}
.dark .smart-hero-pro-bullets li:before {
  content: "🔷";
  color: #ffffffff;
}

/* ====== MAIN STYLES: Glass & Responsive ====== */
.services-wrapper {
  font-family: 'Segoe UI', 'Cairo', Arial, sans-serif;
  background: linear-gradient(120deg, #f5fafd 0%, #e5ebf9 100%);
  min-height: 100vh;
  padding-top: 0;
}
.section-outer {
  position: relative;
  z-index: 1;
  overflow: visible;
}
.section-bg {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 0;
  opacity: 0.11;
  pointer-events: none;
  background: radial-gradient(ellipse at 65% 30%, #1b4fbdff 15%, transparent 60%), radial-gradient(ellipse at 10% 70%, #e8c1a2 20%, transparent 65%);
}
.service-section {
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 54px;
  margin: 0 auto 60px auto;
  max-width: 1180px;
  padding: 48px 4vw;
  border-radius: 40px;
  box-shadow: 0 4px 36px 0 rgba(40,80,150,0.09), 0 2px 8px 0 rgba(80,150,255,0.03);
  background: rgba(255,255,255,0.79);
  backdrop-filter: blur(5px);
  transition: box-shadow 0.33s;
  border: 1.5px solid #e6ebff;
}
.service-section:not(:last-child) { margin-bottom: 52px; }
.service-section.reverse {
  flex-direction: row-reverse;
  background: rgba(247,249,255,0.85);
}
.service-image {
  flex: 1 1 38%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 230px;
  z-index: 1;
}
.service-image img {
  width: 98%;
  max-width: 410px;
  height: 320px;
  object-fit: cover;
  border-radius: 32px;
  box-shadow: 0 8px 46px 0 rgba(41,80,180,0.12), 0 1.5px 10px 0 rgba(80,150,255,0.10);
  border: 3.2px solid #d2e8fa;
  background: #f2f7fd;
  transition: transform 0.38s cubic-bezier(.4,2,.55,.99), box-shadow 0.35s;
  filter: grayscale(0.03) brightness(1);
  animation: fadeinup 0.7s cubic-bezier(.13,.88,.55,.96) backwards;
}
@keyframes fadeinup {
  0% { opacity: 0; transform: translateY(35px) scale(0.98);}
  100% { opacity: 1; transform: translateY(0) scale(1);}
}
.service-image img:hover {
  transform: scale(1.045) rotate(-1.1deg);
  box-shadow: 0 16px 56px 0 rgba(44,77,147,0.19), 0 4px 24px 0 rgba(44,77,147,0.15);
}
.service-content {
  flex: 1 1 60%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 26px 40px 26px 40px;
  background: rgba(255,255,255,0.67);
  border-radius: 24px;
  box-shadow: 0 2px 14px 0 rgba(50,110,210,0.07);
  position: relative;
  z-index: 2;
  animation: fadeinleft 0.75s cubic-bezier(.13,.88,.55,.96) backwards;
}
@keyframes fadeinleft {
  0% { opacity: 0; transform: translateX(60px) scale(0.96);}
  100% { opacity: 1; transform: translateX(0) scale(1);}
}
.reverse .service-content { padding: 26px 40px 26px 40px; }
.service-content h2 {
  font-size: 2.05rem;
  font-weight: 800;
  margin-bottom: 13px;
  color: #1b4fbdff;
  letter-spacing: -1.3px;
  background: linear-gradient(95deg, #1b4fbdff 0% , #32c0ff 1000%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.service-content .subtitle {
  font-size: 1.11rem;
  font-weight: 500;
  color: #1b4fbdff;
  margin-bottom: 18px;
  opacity: 0.92;
  letter-spacing: -0.14px;
}
.service-content ul {
  margin-top: 7px;
  padding-left: 0;
  list-style: none;
}
.service-content li {
  font-size: 1.08rem;
  margin-bottom: 10px;
  position: relative;
  padding-left: 28px;
  line-height: 1.9;
  font-weight: 500;
  letter-spacing: -0.2px;
  transition: color 0.2s;
}
.service-content li:before {
  content: '';
  position: absolute;
  left: 0;
  top: 7px;
  width: 1.3em;
  height: 1.3em;
  background: url('data:image/svg+xml;utf8,<svg fill="%231b4fbd" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="5" /><g><line x1="12" y1="1" x2="12" y2="3" stroke="%231b4fbd" stroke-width="2"/><line x1="12" y1="21" x2="12" y2="23" stroke="%231b4fbd" stroke-width="2"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" stroke="%231b4fbd" stroke-width="2"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" stroke="%231b4fbd" stroke-width="2"/><line x1="1" y1="12" x2="3" y2="12" stroke="%231b4fbd" stroke-width="2"/><line x1="21" y1="12" x2="23" y2="12" stroke="%231b4fbd" stroke-width="2"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" stroke="%231b4fbd" stroke-width="2"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" stroke="%231b4fbd" stroke-width="2"/></g></svg>') no-repeat center center;
  background-size: contain;
  opacity: 1;
  content: '';
}


/* RTL list icon for Arabic */
[dir="rtl"] .service-content li {
  padding-left: 0;
  padding-right: 28px;
}
[dir="rtl"] .service-content li:before {
  left: auto;
  right: 0;
}

@media (max-width: 1100px) {
  .service-section, .service-section.reverse {
    flex-direction: column !important;
    gap: 32px;
    padding: 30px 2vw;
    border-radius: 32px;
    margin-left:8px;
    margin-right:8px;
  }
  .service-image img {
    height: 300px;
    border-radius: 18px;
  }
  .service-content, .reverse .service-content {
    border-radius: 15px;
    padding: 18px 18px;
  }
}
@media (max-width: 680px) {
  .service-section, .service-section.reverse {
    padding: 11px 0vw;
    margin-bottom: 29px;
    border-radius: 12px;
  }
  .service-image img {
    height: 215px;
    border-radius: 9px;
    max-width: 98vw;
  }
  .service-content, .reverse .service-content {
    padding: 8px 8px;
    border-radius: 7px;
  }
  .service-content h2 {
    font-size: 1rem;
    margin-bottom: 4px;
  }
  .service-content .subtitle {
    font-size: 0.95rem;
    margin-bottom: 7px;
  }
  .service-content li {
    font-size: 0.95rem;
    padding-left: 18px;
  }
}
`;

// ==== SECTION DATA (EN & AR) ====
const data = {
  en: [
    {
      image: wifiImg,
      reverse: false,
      title: '🌐 Smart Networking',
      subtitle: "Your home’s performance starts with the right connection.",
      bullets: [
        "Wi-Fi Coverage Planning: Identify and eliminate weak zones; extend reliable coverage with professional-grade access points; ensure strong signals across all rooms and floors.",
        "Secure Device Integration: Seamlessly connect all smart devices, configure routers, firewalls, VLANs; isolate smart home traffic for enhanced security.",
        "Network Performance Optimization: Eliminate latency, reduce interference (Wi-Fi, Zigbee, mesh), troubleshoot slowdowns with expert diagnostics."
      ]
    },
    {
      image: securityImg,
      reverse: true,
      title: '🛡 Smart Security Systems',
      subtitle: "Your safety is redefined with intelligence.",
      bullets: [
        "AI-Powered Security Cameras: Detect people, faces, pets, and babies; enable motion zones, two-way audio, night vision; receive real-time alerts and smart actions.",
        "Smart Sensors & Alarms: Motion, door/window, smoke, gas, water leak detection; trigger instant alerts or routines; customize for day, night, or away.",
        "Smart Alarms & Notifications: Create escalation workflows and scene-based protection; get notified instantly, anywhere."
      ]
    },
    {
      image: intercomImg,
      reverse: false,
      title: '🗣 Smart Intercom Systems',
      subtitle: "Stay connected with who’s at the door or inside the home.",
      bullets: [
        "Video and audio calls to your phone or panel",
        "See and speak to visitors from anywhere",
        "Integrate with door locks and cameras for full access control"
      ]
    },
    {
      image: whyImg,
      reverse: true,
      title: '💬 Why It Matters',
      subtitle: "",
      bullets: [
        "Behind every smooth smart experience is a reliable network and solid security.",
        "We don’t just install — we engineer complete solutions for performance, safety, and peace of mind."
      ]
    },
  ],
  ar: [
    {
      image: wifiImg,
      reverse: false,
      title: "🌐 الشبكة الذكية",
      subtitle: "أداء المنزل الذكي يعتمد على اتصال قوي ومستقر.",
      bullets: [
        "تخطيط تغطية الواي فاي: تحديد ومعالجة المناطق ضعيفة الإشارة؛ تعزيز التغطية باستخدام نقاط وصول احترافية؛ ضمان اتصال قوي في جميع الغرف والطوابق.",
        "ربط الأجهزة بطريقة آمنة: ربط جميع الأجهزة الذكية بسلاسة؛ إعداد أجهزة التوجيه، الجدران النارية، تقسيم الشبكة؛ عزل شبكة الأجهزة الذكية لزيادة الأمان.",
        "تحسين أداء الشبكة: تقليل التأخير وزيادة سرعة الاستجابة؛ تقليل التداخل بين أنظمة الواي فاي وZigbee وغيرها؛ تشخيص وحل مشكلات التباطؤ أو الانقطاع."
      ]
    },
    {
      image: securityImg,
      reverse: true,
      title: '🛡 أنظمة الأمان الذكية',
      subtitle: "الأمان الحقيقي يبدأ بالذكاء.",
      bullets: [
        "كاميرات مراقبة مدعومة بالذكاء الاصطناعي: تمييز الأشخاص والوجوه والحيوانات؛ دعم للرؤية الليلية، مناطق الحركة، والصوت ثنائي الاتجاه؛ تنبيهات فورية وربط مباشر مع أنظمة المنزل الذكي.",
        "مجسات وإنذارات ذكية: حساسات للحركة، الأبواب/النوافذ، الدخان، الغاز، وتسرب المياه؛ تشغيل إنذارات أو أوامر تلقائية؛ تخصيص الاستجابات حسب الحالة.",
        "إنذارات وتنبيهات مخصصة: تصميم سيناريوهات حماية؛ الحصول على تنبيهات فورية أينما كنت."
      ]
    },
    {
      image: intercomImg,
      reverse: false,
      title: '🗣 أنظمة الاتصال الداخلي الذكي (الإنتركم)',
      subtitle: "ابقَ على تواصل مع من يطرق بابك، من أي مكان.",
      bullets: [
        "مكالمات فيديو وصوت مباشرة إلى هاتفك أو شاشة داخلية",
        "رؤية والتحدث مع الزائرين عن بُعد",
        "الربط مع الكاميرات وأقفال الأبواب للتحكم الكامل في الوصول"
      ]
    },
    {
      image: whyImg,
      reverse: true,
      title: "💬 لماذا هذا مهم؟",
      subtitle: "",
      bullets: [
        "المنزل الذكي لا يكتمل بدون شبكة قوية ونظام أمان موثوق.",
        "نحن لا نركب فقط، بل نقدم حلولاً هندسية متكاملة للأداء، الأمان، وراحة البال."
      ]
    },
  ]
};

function NetworkHero() {
  const { language } = useLanguage();
  const isAr = language === 'ar';
  const t = heroTexts[language];
  return (
    <div
      className="network-hero-bg"
      dir={isAr ? 'rtl' : 'ltr'}
      style={{
        background: `linear-gradient(to right,rgba(31,41,55,0.69),rgba(34,151,230,0.18)), url(${heroBgImg}) center/cover`,
        color: '#fff',
        textAlign: 'center',
        padding: '7.2rem 1rem 4.1rem',
        position: 'relative',
        zIndex: 2,
        minHeight: '411px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginBottom: '40px', // <-- This is the new line!
      }}
    >
      <style>{`
        .network-hero-title {
          font-size:3.1rem;
          font-weight: 700;
          color: #fff;
          letter-spacing: -2.5px;
          line-height: 1.09;
          text-align: center;
        }
        .network-hero-subtitle {
          font-size: 1.20rem;
          font-weight: 400;
          color: #fff;
          text-align: center;
          margin-bottom: 10px;
          text-shadow: 0 2px 18px #1d326955;
        }
        .network-hero-desc {
          font-size: 1.22rem;
          color: #e9f1f9;
          text-align: center;
          margin: 0 auto;
          margin-bottom: 0;
          font-weight: 400;
          max-width: 840px;
          text-shadow: 0 1.5px 10px #0e2a4d6d;
        }
        @media (max-width: 800px) {
          .network-hero-title { font-size: 2.2rem; }
          .network-hero-subtitle { font-size: 1.09rem; }
          .network-hero-desc { font-size: 0.98rem; }
          .network-hero-bg { margin-bottom: 26px; }
        }
      `}</style>
      <div>
        <h1 className="network-hero-title">{t.title}</h1>
        <div className="network-hero-subtitle">{t.subtitle}</div>
      </div>
    </div>
  );
}




// ==== SECTION COMPONENT ====
const ServiceSection = ({ content, image, reverse, isAr }) => (
  <div className="section-outer">
    <div className="section-bg" />
    <div className={`service-section${reverse ? ' reverse' : ''}`} dir={isAr ? 'rtl' : 'ltr'}>
      <div className="service-image">
        <img src={image} alt={content.title} loading="lazy" />
      </div>
      <div className="service-content" style={{ textAlign: isAr ? 'right' : 'left' }}>
        <h2>{content.title}</h2>
        <p className="subtitle">{content.subtitle}</p>
        <ul>
          {content.bullets.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

// ==== CTA SECTION ====
const CTASection = ({ language }) => (
  <div className="cta-section">
    {language === 'en' ? (
      <>
        <h2>Let’s make your smart home smarter, safer, and more reliable</h2>
        <p>Contact us today to schedule your free consultation.</p>
        
        <a href="/contact">
          <FaPhone /> Book your free consultation with Mass Smart Solutions today.
        </a>
      </>
    ) : (
      <>
        <h2>اجعل منزلك الذكي أكثر أمانًا واستقرارًا وكفاءة</h2>
        <p>تواصل معنا اليوم واحصل على استشارة مجانية</p>
        <a href="/contact">
            احجز استشارتك المجانية اليوم مع ماس للحلول الذكية <FaPhone />
        </a>
      </>
    )}
  </div>
);

// ==== MAIN PAGE ====
const NetworkSecurityOptimizationPage = () => {
  const { language } = useLanguage();
  const isAr = language === 'ar';
  const sectionData = data[language];

  return (
    <div className="services-wrapper">
      <style>{styles}</style>
      <NetworkHero />
      {sectionData.map((s, i) => (
        <ServiceSection
          key={i}
          content={s}
          image={s.image}
          reverse={s.reverse}
          isAr={isAr}
        />
      ))}
      <CTASection language={language} />
    </div>
  );
};

export default NetworkSecurityOptimizationPage;
